<template>
	<div>
		<div class="scrollContainer">
			<v-card
				class="bannerCard"
				elevation="5"
				v-if="Object.keys(salaryTargetData).length > 0"
			>
				<salary-target-banner :salaryData="salaryTargetData" />
			</v-card>
		</div>
		<v-bottom-sheet v-model="bottomSheet" max-width="600px">
			<v-sheet class="text-center px-4 py-5" height="auto">
				<v-btn
					fab
					flat
					class="top-right-align pa-0 ma-0"
					@click="bottomSheet = !bottomSheet"
				>
					<v-icon>close</v-icon>
				</v-btn>
				<salary-target-banner
					:salaryData="salaryTargetData"
					key="salaryBannerBottomSheet"
					v-if="showSalaryBottomSheet"
				/>
				<bonus-target-banner
					:bonusData="bonusTargetData[showBonusBottomSheet - 1]"
					v-if="showBonusBottomSheet > 0"
					:key="`bonusBottomSheet${showBonusBottomSheet}`"
				/>
				<!-- <div
					class="text-left grey--text text--darken caption font-weight-bold pt-3"
					v-if="isJeet11Executive"
				>
					<span class="body-2">Disclaimer : </span><br />
					1.Min 15 Active Retailer ({{
						retailSalaryData.retailerTarget.isGmvTarget || false
							? "GMV"
							: "Tertiary"
					}}>3000) to be eligible for any payment - Old DSE<br />
					2.Min 70% Active Retail Customers should be old customers -
					Old DSE<br />
					3.Min 5 Active Retailer ({{
						retailSalaryData.retailerTarget.isGmvTarget || false
							? "GMV"
							: "Tertiary"
					}}>3000) to be eligible for any payment - New DSE
				</div> -->
				<div
					class="text-left grey--text text--darken caption font-weight-bold pt-3"
					v-if="
						isJeet11Executive &&
							this.salaryTargetData.oldUserCount >= 0
					"
				>
					OLD USERS COUNT: {{ this.salaryTargetData.oldUserCount
					}}<br />
					NEW USERS COUNT: {{ this.salaryTargetData.newUserCount }}
				</div>
				<target-details-table
					:salaryData="bottomSheetData"
					:dataHeaders="dataHeaders"
					:highlightIndex="highlightIndex"
					:isJeet11Executive="isJeet11Executive"
				/>
			</v-sheet>
		</v-bottom-sheet>
	</div>
</template>
<script>
import SalaryTargetBanner from "./SalaryTargetBanner";
import BonusTargetBanner from "./BonusTargetBanner";
import TargetDetailsTable from "./TargetDetailsTable.vue";

export default {
	name: "TargetBanner",
	props: ["retailSalaryData", "isJeet11Executive", "monthlyCommission"],
	components: {
		"salary-target-banner": SalaryTargetBanner,
		"bonus-target-banner": BonusTargetBanner,
		"target-details-table": TargetDetailsTable
	},
	data() {
		return {
			salaryTargetData: {},
			bonusTargetData: [],
			bottomSheet: false,
			showSalaryBottomSheet: false,
			showBonusBottomSheet: 0,
			bottomSheetData: [],
			highlightIndex: -1,
			dataHeaders: {},
			monthlyCommissionData: {},
			growthTarget: {},
			activeRetailersTarget: {}
		};
	},
	methods: {
		saveDetails() {
			const isGmvTarget =
				this.retailSalaryData.retailerTarget.isGmvTarget || false;
			const salaryData = this.retailSalaryData.retailerTarget.salaryData;
			if (!salaryData.length) return;
			const {
				count: currentActiveCustomers,
				newUserCount,
				oldUserCount
			} = salaryData[0].customerLimit
				? this.retailSalaryData.activeCustomers.filter(
						el =>
							el.targetLowerLimit === salaryData[0].customerLimit
				  )[0]
				: { count: 0, oldUserCount: 0, newUserCount: 0 };
			const activePayoutIndex = salaryData[0].target.findIndex(
				el => el.payout === this.retailSalaryData.salaryPayout
			);
			const targetPayoutIndex = Math.min(
				salaryData[0].target.length - 1,
				activePayoutIndex + 1
			);
			this.salaryTargetData = {
				isGmvTarget,
				customerLimit: salaryData[0].customerLimit,
				active: {
					value: this.retailSalaryData.targetAchieved,
					activeCustomers: currentActiveCustomers,
					payout:
						activePayoutIndex >= 0
							? salaryData[0].target[activePayoutIndex].payout
							: 0
				},
				next: salaryData[0].target[targetPayoutIndex],
				newUserCount,
				oldUserCount
			};
			const bonusData = this.retailSalaryData.retailerTarget.bonusData;
			if (!bonusData.length) return;
			bonusData.forEach(data => {
				const customerLimit = data.customerLimit;
				const currentActiveCustomers = this.retailSalaryData.activeCustomers.filter(
					el => el.targetLowerLimit === customerLimit
				)[0].count;

				const activePayoutIndex = data.target.reduce(
					(payoutIndex, el, currIndex) => {
						if (el.activeCustomers <= currentActiveCustomers)
							payoutIndex = currIndex;
						return payoutIndex;
					},
					-1
				);

				const targetPayoutIndex = Math.min(
					data.target.length - 1,
					activePayoutIndex + 1
				);
				this.bonusTargetData.push({
					isGmvTarget,
					customerLimit,
					currentActiveCustomers,
					active: data.target[activePayoutIndex] || {
						activeCustomers: 0,
						payout: 0
					},
					next: data.target[targetPayoutIndex]
				});
			});
			if (this.isJeet11Executive) {
				this.monthlyCommissionData = {
					target: {
						from: 0,
						to:
							this.monthlyCommission.executivePremiumSoldLimit ||
							0
					},
					reward: {
						from: 0,
						to: this.monthlyCommission.executivePremiumReward
					},
					current: this.monthlyCommission.premiumSold
				};
			}
			if (this.retailSalaryData.retailerTarget) {
				const {
					previousTargetAchieved = 0,
					growthNeeded = 0
				} = this.retailSalaryData.retailerTarget;
				const gmvAchieved = this.retailSalaryData.targetAchieved || 0;
				const requiredGrowth =
					previousTargetAchieved * (1 + 0.01 * growthNeeded);
				const dt = new Date();
				const daysInPrevMonth = new Date(
					dt.getFullYear(),
					dt.getMonth(),
					0
				).getDate();
				const daysInCurrMonth = new Date(
					dt.getFullYear(),
					dt.getMonth() + 1,
					0
				).getDate();
				const currentGR = (gmvAchieved / dt.getDate()).toFixed(2);
				const previousGR = (
					previousTargetAchieved / daysInPrevMonth
				).toFixed(2);
				const requiredGR = (requiredGrowth / daysInCurrMonth).toFixed(
					2
				);
				this.growthTarget = {
					previousTargetAchieved,
					growthPercentNeeded: growthNeeded,
					gmvAchieved,
					requiredGrowth,
					currentGR,
					previousGR,
					requiredGR
				};

				if (
					this.retailSalaryData.activeRetailers &&
					this.retailSalaryData.retailerTarget.salaryData.length > 0
				) {
					const {
						target,
						retailerLimit
					} = this.retailSalaryData.retailerTarget.salaryData[0];
					const targetRetailerCount = target[0].activeRetailers;
					const activeRetailerCount =
						this.retailSalaryData.activeRetailers.filter(
							el => el.targetLowerLimit === retailerLimit
						)[0].count || 0;
					this.activeRetailersTarget = {
						targetRetailerCount,
						activeRetailerCount
					};
				}
			}
		},
		showBottomSheet(salaryBottomSheet, index = 0) {
			const isGmvTarget =
				this.retailSalaryData.retailerTarget.isGmvTarget || false;
			this.showBonusBottomSheet = 0;
			this.showSalaryBottomSheet = false;
			this.highlightIndex = -1;
			if (salaryBottomSheet) {
				this.dataHeaders = {
					value: isGmvTarget ? "GMV" : "TS",
					...(this.salaryTargetData.customerLimit > 0
						? {
								activeCustomers: `${
									isGmvTarget ? "Cust(GMV" : "Customer(T"
								}>=${this.salaryTargetData.customerLimit})`
						  }
						: {}),
					payout: "Salary"
				};
				this.bottomSheetData = this.retailSalaryData.retailerTarget.salaryData[0].target;
				this.highlightIndex = this.bottomSheetData.findIndex(
					el => el.payout === this.retailSalaryData.salaryPayout
				);
				this.showSalaryBottomSheet = true;
			} else {
				this.dataHeaders = {
					activeCustomers: `${
						isGmvTarget ? "Cust(GMV" : "Customer(T"
					}>=${this.bonusTargetData[index].customerLimit})`,
					payout: "Salary"
				};
				this.bottomSheetData = this.retailSalaryData.retailerTarget.bonusData[
					index
				].target;
				this.showBonusBottomSheet = index + 1;
			}
			this.bottomSheet = true;
		}
	},
	mounted() {
		this.saveDetails();
	}
};
</script>
<style scoped>
.scrollContainer {
	max-width: 100%;
	display: flex;
	overflow: auto;
}
.bannerCard {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	flex-grow: 0;
	flex-shrink: 0;
	width: 88%;
	max-width: 600px;
	padding: 8px 1em;
	border-radius: 16px;
	margin: 1em 0.8em;
}
.max-w-fit-content {
	max-width: fit-content;
}
.gmv-text {
	font-size: 18px;
	font-weight: bold;
	color: #18c9b9;
}
.progress-bar {
	background-color: #e1e4ec;
	border-radius: 4px;
	width: 100%;
	margin: 0 1em;
}
.progress-bar > div {
	background: linear-gradient(90deg, #12e9b5 0%, #295cc5 100%),
		linear-gradient(270deg, #26a67b 0%, #75efc6 100%);
	height: 8px;
	border-radius: 4px;
}
.data-table > div:nth-child(odd) {
	background: #e7eaf9;
}
.data-table > div:nth-child(even) {
	background: rgba(195, 218, 254, 0.2);
}
.data-table > div:first-child {
	background: #2d4970;
	border-radius: 8px 8px 0 0;
}
.data-table > div:last-child {
	border-radius: 0 0 8px 8px;
}
</style>
